import React, { useState, useEffect } from 'react';
import axios from 'axios';
// @ts-ignore
import debounce from 'lodash.debounce';
import API_BASE_URL from '../../config';
import { useTranslation } from 'react-i18next';
export type ArticleType = {
  _id: string;
  subheading: string;
  title: string;
  video?: string | null;
  content?: string | null;
  published: boolean;
  published_at: string;
  image: string;
};

type AllDataType = {
  articles: ArticleType[]; // Assuming ArticleType is another type you've defined
  totalPages: number; // Add totalPages property to match the expected structure
};
type Props = {
  onSearch: (results: AllDataType) => void; // Podés tiparlo mejor si querés
};

const SearchInput: React.FC<Props> = ({ onSearch }) => {
    const [query, setQuery] = useState('');
    const { t }: { t: (key: string, options?: any) => string } = useTranslation();
    const fetchData = debounce(async (text: string) => {
      const trimmedText = text.trim();

      if (trimmedText.length < 2 && trimmedText !== '') return;
      try {
        const response = await axios.get(`${API_BASE_URL}/articles/search?q=${trimmedText}`);
        onSearch(response.data);
      } catch (error) {
        console.error('Searching error:', error);
      }
    }, 500);

  useEffect(() => {
    fetchData(query);
    return fetchData.cancel;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <div className="p-4">
      <label className="sr-only">{t('Search')}</label>
      <div className="relative mt-1">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clipRule="evenodd"></path>
            </svg>
          </div>
      </div>
      <div className="p-4">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t('Search')}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
        />
      </div>
    </div>
  );
};

export default SearchInput;

